/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react'

// Base props that all dialogs must implement
export type BaseDialogProps = {
  open: boolean
  onClose?: () => void
}

// Type for any dialog component that extends BaseDialogProps
export type DialogComponent<P = Record<string, unknown>> = React.ComponentType<BaseDialogProps & P>

// Structure for dialogs in the provider state
export type DialogInstance = {
  id: string
  Component: DialogComponent<any>
  props: any
}

// Context value type
export type DialogContextValue = {
  openDialog: <P extends Record<string, unknown>>(
    Component: DialogComponent<P>,
    props: Omit<P & BaseDialogProps, 'open'>
  ) => string
  closeDialog: (id: string) => void
  closeAllDialogs: () => void
}

// Dialog Provider Props
export type DialogProviderProps = {
  children: React.ReactNode
}

export const DialogContext = createContext<DialogContextValue | undefined>(undefined)

export const useDialog = () => {
  const context = useContext(DialogContext)

  if (!context) {
    throw new Error('useDialog must be used within a DialogProvider')
  }

  return context
}